import { useState } from 'react'

type RefetchFunction = () => Promise<any> | null
type RefreshOptions = {
  silentRefresh?: boolean
}

export const useQueryRefresh = (
  refetch: RefetchFunction[] | RefetchFunction,
) => {
  const [refreshing, setRefreshing] = useState(false)
  const refresh = async (options?: RefreshOptions) => {
    const { silentRefresh } = options || {}
    !silentRefresh && setRefreshing(true)

    try {
      if (!Array.isArray(refetch)) {
        await refetch?.()
      } else {
        await Promise.all(refetch.map((func) => func?.()))
      }
    } finally {
      !silentRefresh && setRefreshing(false)
    }
  }

  return { refresh, refreshing }
}
